<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/user/profile' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <back-box>
      <div class="update-psw-box">
        <el-form ref="form" :model="user" :rules="rules" label-width="100px">
          <el-form-item label="原始密码">
            <el-input
              v-model="user.oldPassword"
              placeholder="长度在6到20个字符"
              maxlength="20"
              :type="oldType"
            >
              <div slot="suffix">{{oldLength}}/20</div>
            </el-input>
            <i :class="oldIcon" @click="showPass(0)"></i>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              v-model="user.newPassword"
              placeholder="长度在6到20个字符"
              maxlength="20"
              :type="newType"
            >
              <div slot="suffix">{{newLength}}/20</div>
            </el-input>
            <i :class="newIcon" @click="showPass(1)"></i>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              v-model="user.confirmPassword"
              placeholder="长度在6到20个字符"
              maxlength="20"
              :type="confirmType"
            >
              <div slot="suffix">{{confirmLength}}/20</div>
            </el-input>
            <i :class="confirmIcon" @click="showPass(2)"></i>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </back-box>
  </div>
</template>

<script>
import backBox from "../../../components/backBox";
import { updateUserPwd } from "@/api/system/user";
export default {
  components: { backBox },
  // 定义属性
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      oldType: "password",
      newType: "password",
      confirmType: "password",
      oldIcon: "icon iconfont iconicon-zhanxian",
      newIcon: "icon iconfont iconicon-zhanxian",
      confirmIcon: "icon iconfont iconicon-zhanxian",
      oldLength: 0,
      newLength: 0,
      confirmLength: 0,
      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
      },
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    user: {
      handler: function (val) {
        // debugger
        this.oldLength = val.oldPassword.length;
        this.newLength = val.newPassword.length;
        this.confirmLength = val.confirmPassword.length;
      },
      deep: true,
    },
  },
  // 方法集合
  methods: {
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          updateUserPwd(this.user.oldPassword, this.user.newPassword).then(
            (response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功");
                this.$store.dispatch("LogOut").then(() => {
                  location.reload();
                });
              }
            }
          );
        }
      });
    },
    //密码的隐藏和显示
    showPass(type) {
      if (type == 0) {
        //点击图标是密码隐藏或显示
        if (this.oldType == "text") {
          this.oldType = "password";
          //更换图标
          this.oldIcon = "icon iconfont iconicon-zhanxian";
        } else {
          this.oldType = "text";
          this.oldIcon = "icon iconfont iconicon-yincang";
        }
      } else if (type == 1) {
        if (this.newType == "text") {
          this.newType = "password";
          //更换图标
          this.newIcon = "icon iconfont iconicon-zhanxian";
        } else {
          this.newType = "text";
          this.newIcon = "icon iconfont iconicon-yincang";
        }
      } else if (type == 2) {
        if (this.confirmType == "text") {
          this.confirmType = "password";
          //更换图标
          this.confirmIcon = "icon iconfont iconicon-zhanxian";
        } else {
          this.confirmType = "text";
          this.confirmIcon = "icon iconfont iconicon-yincang";
        }
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss'>
.update-psw-box {
  margin: 60px 30px;
  .el-form-item {
    margin-bottom: 50px;
  }
  .el-form-item__content {
    width: 400px !important;
    text-align: left;
  }
  .el-input__inner {
    height: 40px;
    background-color: rgba(28, 54, 89, 0.2);
    border-radius: 2px;
    color: white;
    border: solid 2px #dddddd !important;
  }
  .icon {
    padding-left: 10px;
    position: absolute;
    color: white;
  }
  .btn {
    text-align: left;
    width: 120px;
    height: 46px;
    background-color: #e88634;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    border: none;
  }
}
</style>
